module.exports = __webpack_public_path__ + "img/ttd.b3195543.png";